export const listaMeses = [
  { label: 'Jan', value: 1 },
  { label: 'Fev', value: 2 },
  { label: 'Mar', value: 3 },
  { label: 'Abr', value: 4 },
  { label: 'Mai', value: 5 },
  { label: 'Jun', value: 6 },
  { label: 'Jul', value: 7 },
  { label: 'Ago', value: 8 },
  { label: 'Set', value: 9 },
  { label: 'Out', value: 10 },
  { label: 'Nov', value: 11 },
  { label: 'Dez', value: 12 },
];

export const listaAnos = (anoInicial = 2017) => {
  return Array.from({ length: new Date().getFullYear() - anoInicial + 1 }, (_, i) => {
    const ano = new Date().getFullYear() - i;
    return { label: ano, value: ano };
  });
};
